'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Testimonials = exports.TestimonialsUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _nukaCarousel = require('nuka-carousel');

var _nukaCarousel2 = _interopRequireDefault(_nukaCarousel);

var _reactIntl = require('react-intl');

var _multitrack = require('helpers/multitrack');

var _TrackDwell = require('decorators/TrackDwell/TrackDwell');

var _TrackDwell2 = _interopRequireDefault(_TrackDwell);

var _Media = require('decorators/Media/Media');

var _Media2 = _interopRequireDefault(_Media);

var _Controls = require('../../../Carousel/Controls');

var _testimonialsData = require('./testimonialsData');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TestimonialsUnwrapped = exports.TestimonialsUnwrapped = function (_Component) {
  (0, _inherits3.default)(TestimonialsUnwrapped, _Component);

  function TestimonialsUnwrapped() {
    (0, _classCallCheck3.default)(this, TestimonialsUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (TestimonialsUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(TestimonialsUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(TestimonialsUnwrapped, [{
    key: 'onDwell',
    value: function onDwell() {
      (0, _multitrack.ga)('Testimonials Module', 'Viewed testimonials module', '', 0, { nonInteraction: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var testimonials = _testimonialsData.testimonialsData;
      var _props = this.props,
          mediaQueryMd = _props.mediaQueryMd,
          backgroundColor = _props.backgroundColor;


      return _react2.default.createElement(
        'div',
        { className: 'testimonials bg--' + (backgroundColor || 'white') },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h2',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'testimonials.header',
              defaultMessage: 'What members have to say'
            })
          ),
          _react2.default.createElement(
            _nukaCarousel2.default,
            {
              decorators: mediaQueryMd ? [{
                component: _Controls.CarouselPrev,
                position: 'CenterLeft'
              }, {
                component: _Controls.CarouselNext,
                position: 'CenterRight'
              }] : [{
                component: _Controls.Pagination,
                position: 'BottomCenter'
              }],
              className: 'carousel--testimonials',
              cellAlign: 'left',
              edgeEasing: 'easeOut',
              speed: 150,
              slidesToShow: 1,
              slidesToScroll: 1
            },
            testimonials.map(function (testimonial) {
              return _react2.default.createElement(
                'div',
                { className: 'testimonials__item', key: testimonial.source },
                _react2.default.createElement(
                  'blockquote',
                  null,
                  testimonial.quote
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'testimonials__item__source' },
                  _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                      'h3',
                      null,
                      testimonial.source
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      testimonial.location
                    )
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);
  return TestimonialsUnwrapped;
}(_react.Component);

TestimonialsUnwrapped.propTypes = {
  mediaQueryMd: _propTypes2.default.bool,
  backgroundColor: _propTypes2.default.oneOf(['white', 'light'])
};

var Testimonials = exports.Testimonials = (0, _Media2.default)((0, _TrackDwell2.default)(TestimonialsUnwrapped));